var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/inclusionCodeMapping/common.ts
var isPresent = /* @__PURE__ */ __name((x) => x !== void 0 && x !== null, "isPresent");

// src/inclusionCodeMapping/hotel.ts
var hotelType = /* @__PURE__ */ __name((itemCode) => itemCode.slice(2, 5), "hotelType");
var hotelNumberOfDays = /* @__PURE__ */ __name((itemCode) => parseInt(itemCode.slice(0, 2)), "hotelNumberOfDays");
var isMaybeHotel = /* @__PURE__ */ __name((productCode) => productCode === "HTL", "isMaybeHotel");
var hotelInclusionCodeFrom = /* @__PURE__ */ __name(({ productCode, itemCode }) => {
  if (!isMaybeHotel(productCode))
    return void 0;
  if (hotelType(itemCode) === "PRE")
    return "PreHotel";
  if (hotelType(itemCode) === "PST")
    return hotelNumberOfDays(itemCode) === 0 ? "PostDayStay" : "PostHotel";
  return void 0;
}, "hotelInclusionCodeFrom");

// src/inclusionCodeMapping/cruise.ts
var classicCruiseInclusionCodes = ["Butler", "FoodAndBeverage"];
var unknownCruiseInclusionCodes = [...classicCruiseInclusionCodes, "ExpeditionCruiseExtras"];
var expeditionCruiseInclusionCodes = [
  ...classicCruiseInclusionCodes,
  "FreeShorexExpedition",
  "SpecialEquipments"
];
var cruiseInclusionCodesFrom = /* @__PURE__ */ __name(({ cruiseType, current }) => {
  if (!isCruise(current))
    return [];
  if (cruiseType === void 0)
    return unknownCruiseInclusionCodes;
  if (cruiseType === "Expedition")
    return expeditionCruiseInclusionCodes;
  return classicCruiseInclusionCodes;
}, "cruiseInclusionCodesFrom");
var isCruise = /* @__PURE__ */ __name((x) => x.itemCode === "CRU FARE" && x.productCode === "CRZ", "isCruise");

// src/inclusionCodeMapping/airContext.ts
var AirContext = {
  init: (context, inclusions) => ({
    ...context,
    prevs: [],
    current: inclusions[0],
    nexts: inclusions.slice(1)
  }),
  forward: (context) => {
    const { nexts, prevs } = context;
    if (!context.current)
      return void 0;
    if (nexts.length === 0)
      return void 0;
    return {
      ...context,
      prevs: [...prevs, context.current],
      current: nexts[0],
      nexts: nexts.slice(1)
    };
  },
  mapForward: (f, context) => {
    const ret = [f(context)];
    let next = context;
    while ((next = AirContext.forward(next)) !== void 0)
      ret.push(f(next));
    return ret;
  },
  backward: (context) => {
    const { prevs, nexts } = context;
    if (!context.current)
      return void 0;
    if (prevs.length === 0)
      return void 0;
    return {
      ...context,
      prevs: prevs.slice(0, -1),
      current: prevs.slice(-1)[0],
      nexts: [context.current, ...nexts]
    };
  },
  mapBackward: (f, context) => {
    const ret = [f(context)];
    let prev = context;
    while ((prev = AirContext.backward(prev)) !== void 0)
      ret.push(f(prev));
    return ret;
  },
  cruiseIsBefore: (context) => context.prevs.some(isCruise),
  cruiseIsAfter: (context) => context.nexts.some(isCruise)
};

// src/inclusionCodeMapping/air.ts
var antarcticaBridgeFlightArrivalGateways = ["KGG"];
var internationalGatewaysRegEx = /^\s*([A-Z]{3})\/([A-Z]{3})\s*$/;
var inCountryGatewaysRegEx = /^\s*([A-Z]{3})([A-Z]{3})\s*$/;
var internationalGatewaysT = /* @__PURE__ */ __name((itemCode) => {
  const match = internationalGatewaysRegEx.exec(itemCode);
  if (match)
    return [match[1], match[2], true];
  return void 0;
}, "internationalGatewaysT");
var inCountryGatewaysT = /* @__PURE__ */ __name((itemCode) => {
  const match = inCountryGatewaysRegEx.exec(itemCode);
  if (match)
    return [match[1], match[2], false];
  return void 0;
}, "inCountryGatewaysT");
var gateways = /* @__PURE__ */ __name(({ productCode, itemCode }) => {
  var _a;
  const gws = (_a = internationalGatewaysT(itemCode)) != null ? _a : inCountryGatewaysT(itemCode);
  return isMaybeAir(productCode) && gws ? { from: gws[0], to: gws[1], isInternational: gws[2] } : void 0;
}, "gateways");
var isInternationalFlight = /* @__PURE__ */ __name((item) => {
  var _a;
  return ((_a = gateways(item)) == null ? void 0 : _a.isInternational) === true;
}, "isInternationalFlight");
var isInCountryFlight = /* @__PURE__ */ __name((item) => {
  var _a;
  return ((_a = gateways(item)) == null ? void 0 : _a.isInternational) === false;
}, "isInCountryFlight");
var isInternationalFlightsItemCode = /* @__PURE__ */ __name(({ productCode, itemCode }) => isMaybeAir(productCode) && ["OUTBOUND", "INBOUND"].includes(itemCode), "isInternationalFlightsItemCode");
var isMaybeAir = /* @__PURE__ */ __name((productCode) => productCode === "AIR", "isMaybeAir");
var isPreAntarcticaBridgeFlight = /* @__PURE__ */ __name((item) => {
  var _a;
  return isInCountryFlight(item) && antarcticaBridgeFlightArrivalGateways.includes(((_a = gateways(item)) == null ? void 0 : _a.to) || "");
}, "isPreAntarcticaBridgeFlight");
var isPostAntarcticaBridgeFlight = /* @__PURE__ */ __name((item) => {
  var _a;
  return isInCountryFlight(item) && antarcticaBridgeFlightArrivalGateways.includes(((_a = gateways(item)) == null ? void 0 : _a.from) || "");
}, "isPostAntarcticaBridgeFlight");
var inCountryFlights = /* @__PURE__ */ __name((item, context) => {
  if (!isInCountryFlight(item))
    return void 0;
  if (AirContext.cruiseIsAfter(context))
    return "PreInCountryFlight";
  if (AirContext.cruiseIsBefore(context))
    return "PostInCountryFlight";
  return void 0;
}, "inCountryFlights");
var genericAirInclusionCodeFrom = /* @__PURE__ */ __name((context) => {
  const { current } = context;
  if (isInternationalFlightsItemCode(current))
    return "InternationalFlights";
  if (isInternationalFlight(current))
    return "InternationalFlights";
  if (isPreAntarcticaBridgeFlight(current))
    return "PreAntarcticaBridgeFlight";
  if (isPostAntarcticaBridgeFlight(current))
    return "PostAntarcticaBridgeFlight";
  return inCountryFlights(current, context);
}, "genericAirInclusionCodeFrom");
var previousGenericAirInclusionCode = /* @__PURE__ */ __name((context) => AirContext.mapBackward(genericAirInclusionCodeFrom, context).find((x) => x !== void 0), "previousGenericAirInclusionCode");
var followingGenericAirInclusionCode = /* @__PURE__ */ __name((context) => AirContext.mapForward(genericAirInclusionCodeFrom, context).find((x) => x !== void 0), "followingGenericAirInclusionCode");
var internationalFlightCategoryFrom = /* @__PURE__ */ __name((airPromotionAmounts) => {
  if (!airPromotionAmounts)
    return "InternationalFlights";
  if (airPromotionAmounts.businessPromo === 0)
    return "BusinessFlights";
  if (airPromotionAmounts.economyPromo === 0)
    return isPresent(airPromotionAmounts.businessPromo) ? "EconomyFlightsWithUpgrade" : "EconomyFlights";
  return void 0;
}, "internationalFlightCategoryFrom");
var airInclusionCodeFrom = /* @__PURE__ */ __name((context) => genericAirInclusionCodeFrom(context) === "InternationalFlights" ? internationalFlightCategoryFrom(context.airPromotionAmounts) : genericAirInclusionCodeFrom(context), "airInclusionCodeFrom");
var isFlightFrom = /* @__PURE__ */ __name((gateway, item) => {
  var _a;
  return ((_a = gateways(item)) == null ? void 0 : _a.from) === gateway;
}, "isFlightFrom");
var isFlightTo = /* @__PURE__ */ __name((gateway, item) => {
  var _a;
  return ((_a = gateways(item)) == null ? void 0 : _a.to) === gateway;
}, "isFlightTo");

// src/inclusionCodeMapping/transfer.ts
var isDoorToDoorItemCode = /* @__PURE__ */ __name((itemCode) => /^PVT/.test(itemCode), "isDoorToDoorItemCode");
var doorToDoorTransferInclusionCodeFrom = /* @__PURE__ */ __name((itemCode) => {
  if (itemCode === "PVTHOTFROU")
    return "PreDoor2Door";
  if (itemCode === "PVTHOTFRIN")
    return "PostDoor2Door";
  return void 0;
}, "doorToDoorTransferInclusionCodeFrom");
var transferLeg = /* @__PURE__ */ __name((letter) => {
  switch (letter) {
    case "A":
      return "Airport";
    case "H":
      return "Hotel";
    case "P":
      return "Pier";
    default:
      return void 0;
  }
}, "transferLeg");
var transferDeparture = /* @__PURE__ */ __name((itemCode) => transferLeg(itemCode[2]), "transferDeparture");
var transferDestination = /* @__PURE__ */ __name((itemCode) => transferLeg(itemCode[3]), "transferDestination");
var internationAirportToAnyDestination = /* @__PURE__ */ __name((itemCode) => {
  if (transferDeparture(itemCode) !== "Airport")
    return void 0;
  switch (transferDestination(itemCode)) {
    case "Hotel":
      return "TransferInternationalAirportToHotel";
    case "Pier":
      return "TransferInternationalAirportToPier";
  }
  return void 0;
}, "internationAirportToAnyDestination");
var anyDepartureToInternationalAirport = /* @__PURE__ */ __name((itemCode) => {
  if (transferDestination(itemCode) !== "Airport")
    return void 0;
  switch (transferDeparture(itemCode)) {
    case "Hotel":
      return "TransferHotelToInternationalAirport";
    case "Pier":
      return "TransferPierToInternationalAirport";
  }
  return void 0;
}, "anyDepartureToInternationalAirport");
var antarcticaBridgeAirportToAnyDestination = /* @__PURE__ */ __name((itemCode) => transferDeparture(itemCode) === "Airport" && transferDestination(itemCode) === "Hotel" ? "AntarcticaBridgeTransferToHotel" : void 0, "antarcticaBridgeAirportToAnyDestination");
var anyDepartureToAntarcticaBridgeAirport = /* @__PURE__ */ __name((itemCode) => transferDestination(itemCode) == "Airport" && transferDeparture(itemCode) === "Hotel" ? "AntarcticaBridgeTransferToAirport" : void 0, "anyDepartureToAntarcticaBridgeAirport");
var isMaybeTransfer = /* @__PURE__ */ __name((productCode) => productCode === "TFR", "isMaybeTransfer");
var preCruiseTransferInclusionCodeFrom = /* @__PURE__ */ __name((context) => {
  const { itemCode } = context.current;
  if (previousGenericAirInclusionCode(context) === "InternationalFlights")
    return internationAirportToAnyDestination(itemCode);
  if (previousGenericAirInclusionCode(context) === "PreInCountryFlight" && followingGenericAirInclusionCode(context) === "PreAntarcticaBridgeFlight")
    return antarcticaBridgeAirportToAnyDestination(itemCode);
  return void 0;
}, "preCruiseTransferInclusionCodeFrom");
var postCruiseTransferInclusionCodeFrom = /* @__PURE__ */ __name((context) => {
  const { itemCode } = context.current;
  if (followingGenericAirInclusionCode(context) === "InternationalFlights")
    return anyDepartureToInternationalAirport(itemCode);
  if (previousGenericAirInclusionCode(context) === "PostAntarcticaBridgeFlight" && followingGenericAirInclusionCode(context) === "PostInCountryFlight")
    return anyDepartureToAntarcticaBridgeAirport(itemCode);
  return void 0;
}, "postCruiseTransferInclusionCodeFrom");
var transferInclusionCodeFrom = /* @__PURE__ */ __name((context) => {
  const { productCode, itemCode } = context.current;
  if (!isMaybeTransfer(productCode))
    return void 0;
  if (isDoorToDoorItemCode(itemCode))
    return doorToDoorTransferInclusionCodeFrom(itemCode);
  if (AirContext.cruiseIsAfter(context))
    return preCruiseTransferInclusionCodeFrom(context);
  if (AirContext.cruiseIsBefore(context))
    return postCruiseTransferInclusionCodeFrom(context);
  return void 0;
}, "transferInclusionCodeFrom");

// src/inclusionCodeMapping/shorex.ts
var isMaybeShorex = /* @__PURE__ */ __name((productCode) => productCode === "SHX", "isMaybeShorex");
var shorexInclusionCodeFrom = /* @__PURE__ */ __name(({ productCode }) => isMaybeShorex(productCode) ? "FreeShorex" : void 0, "shorexInclusionCodeFrom");

// src/inclusionCodeMapping/singleInclusion.ts
var inclusionsFrom = /* @__PURE__ */ __name((context) => {
  const inclusionCode = inclusionCodeFrom(context);
  if (inclusionCode) {
    return [
      {
        code: inclusionCode,
        date: context.current.itineraryDate
      }
    ];
  } else {
    return cruiseInclusionCodesFrom(context).map((x) => ({
      code: x,
      date: context.current.itineraryDate
    }));
  }
}, "inclusionsFrom");
var inclusionCodeFrom = /* @__PURE__ */ __name((context) => shorexInclusionCodeFrom(context.current) || hotelInclusionCodeFrom(context.current) || airInclusionCodeFrom(context) || transferInclusionCodeFrom(context), "inclusionCodeFrom");

// src/inclusionCodeMapping/allInclusions.ts
var distinct = /* @__PURE__ */ __name((item, index, all) => !all.slice(0, index).includes(item), "distinct");
var isIgnorablePierTransfer = /* @__PURE__ */ __name((item, all) => item === "TransferInternationalAirportToPier" && all.includes("TransferInternationalAirportToHotel") || item === "TransferPierToInternationalAirport" && all.includes("TransferHotelToInternationalAirport"), "isIgnorablePierTransfer");
var ignorePierTransferWhenHotelIsAvailable = /* @__PURE__ */ __name((item, _, all) => !isIgnorablePierTransfer(item, all), "ignorePierTransferWhenHotelIsAvailable");
var ignorePierTransferWhenHotelIsAvailableInclusion = /* @__PURE__ */ __name((item, _, all) => () => !isIgnorablePierTransfer(
  item.code,
  all.map((x) => x.code)
), "ignorePierTransferWhenHotelIsAvailableInclusion");
var allInclusionCodesFrom = /* @__PURE__ */ __name((inclusions, context) => {
  const safeContext = AirContext.init(context, inclusions);
  return AirContext.mapForward(inclusionsFrom, safeContext).flat().map((x) => x.code).filter(ignorePierTransferWhenHotelIsAvailable).filter(distinct);
}, "allInclusionCodesFrom");
var allInclusionsFrom = /* @__PURE__ */ __name((inclusions, context) => {
  const safeContext = AirContext.init(context, inclusions);
  return AirContext.mapForward(inclusionsFrom, safeContext).flat().filter(ignorePierTransferWhenHotelIsAvailableInclusion);
}, "allInclusionsFrom");

// src/inclusionCodeMapping/utils.ts
var addCruiseToInclusions = /* @__PURE__ */ __name((inclusions, cruiseDepartureDate) => {
  const preInclusions = inclusions.filter((x) => x.itineraryDate <= cruiseDepartureDate);
  const postInclusions = inclusions.filter((x) => x.itineraryDate > cruiseDepartureDate);
  return [
    ...preInclusions,
    {
      itineraryDate: cruiseDepartureDate,
      itemCode: "CRU FARE",
      productCode: "CRZ"
    },
    ...postInclusions
  ];
}, "addCruiseToInclusions");

// src/inclusionCode.ts
var miscKeys = {
  PreInCountryFlight: null,
  PostInCountryFlight: null,
  PreDoor2Door: null,
  PostDoor2Door: null,
  PreHotel: null,
  PostHotel: null,
  PostDayStay: null,
  FreeShorex: null,
  FreeShorexExpedition: null,
  Butler: null,
  FoodAndBeverage: null,
  SpecialEquipments: null,
  ExpeditionCruiseExtras: null
};
var internationalAirTransferInclusionKeys = {
  TransferInternationalAirportToHotel: null,
  TransferInternationalAirportToPier: null,
  TransferHotelToInternationalAirport: null,
  TransferPierToInternationalAirport: null
};
var internationalAirInclusionKeys = {
  InternationalFlights: null,
  BusinessFlights: null,
  EconomyFlights: null,
  EconomyFlightsWithUpgrade: null,
  BusinessUpgraded: null
};
var antarcticaBridgeInclusionKeys = {
  PreAntarcticaBridgeFlight: null,
  PostAntarcticaBridgeFlight: null,
  AntarcticaBridgeTransferToHotel: null,
  AntarcticaBridgeTransferToAirport: null
};
var inclusionKeys = /* @__PURE__ */ __name(() => ({
  ...internationalAirInclusionKeys,
  ...internationalAirTransferInclusionKeys,
  ...antarcticaBridgeInclusionKeys,
  ...miscKeys
}), "inclusionKeys");
var INTERNATIONAL_AIR_TRANSFER_INCLUSION_CODES = /* @__PURE__ */ Object.keys(
  internationalAirTransferInclusionKeys
);
var INTERNATIONAL_AIR_INCLUSION_CODES = /* @__PURE__ */ Object.keys(
  internationalAirInclusionKeys
);
var ANTARCTICA_BRIDGE_INCLUSION_CODES = /* @__PURE__ */ Object.keys(
  antarcticaBridgeInclusionKeys
);
var MISC_INCLUSION_CODES = Object.keys(miscKeys);
var INCLUSION_CODES = /* @__PURE__ */ [
  INTERNATIONAL_AIR_INCLUSION_CODES,
  INTERNATIONAL_AIR_TRANSFER_INCLUSION_CODES,
  ANTARCTICA_BRIDGE_INCLUSION_CODES,
  MISC_INCLUSION_CODES
].flat();
export {
  AirContext,
  INCLUSION_CODES,
  INTERNATIONAL_AIR_INCLUSION_CODES,
  INTERNATIONAL_AIR_TRANSFER_INCLUSION_CODES,
  addCruiseToInclusions,
  airInclusionCodeFrom,
  allInclusionCodesFrom,
  allInclusionsFrom,
  gateways,
  hotelInclusionCodeFrom,
  inclusionKeys,
  isCruise,
  isFlightFrom,
  isFlightTo,
  isMaybeAir,
  isMaybeHotel,
  isMaybeShorex,
  isMaybeTransfer,
  shorexInclusionCodeFrom,
  transferInclusionCodeFrom
};
//# sourceMappingURL=index.js.map
